__turbopack_context__.v({
  "active": "stats-module-scss-module__8NlYSa__active",
  "group": "stats-module-scss-module__8NlYSa__group",
  "overrides": "stats-module-scss-module__8NlYSa__overrides",
  "row": "stats-module-scss-module__8NlYSa__row",
  "total": "stats-module-scss-module__8NlYSa__total",
});
